import React, { useEffect } from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  fixedAlert: {
    position: 'absolute',
    top: 0,
    width: '100%',
    borderTop: 'none',
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    cursor: 'pointer',
  },
});

export const Alerta = ({ onClose, text, title = '', timeout = 3000, className = '', ...rest }) => {
  const classes = useStyles();
  useEffect(() => {
    if (timeout) {
      setTimeout(() => {
        rest.show && onClose();
      }, timeout);
    }
  }, [rest.show, onClose, timeout]);

  return (
    <Alert {...rest} onClick={onClose} className={`${className} ${classes.fixedAlert}`}>
      {title && <Alert.Heading>{title}</Alert.Heading>}
      {text}
    </Alert>
  );
};

export const AlertaDialog = ({
  onClose,
  title = '',
  className = '',
  children,
  closeText = 'Aceptar',
  ...rest
}) => {
  const handleClose = () => {
    if (onClose) onClose();
  };

  return (
    <Modal centered {...rest}>
      {title && (
        <Modal.Header>
          <Modal.Title as="h6">{title}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="primary" onClick={handleClose}>
          {closeText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
